<!--
 * @Author: your name
 * @Date: 2022-03-16 14:47:50
 * @LastEditTime: 2022-03-18 16:33:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\components\do\DUpload.vue
-->
<template>
  <a-upload
    name="file"
    :multiple="false"
    :showUploadList="false"
    :file-list="fileList"
    :remove="handleRemove"
    :before-upload="beforeUpload"
  >
    <a-button :loading="uploading" icon="upload" :disabled="uploading">{{ text }}</a-button>
  </a-upload>
  <!-- <a-tree-select
    allowClear
    labelInValue
    :getPopupContainer="(node) => node.parentNode"
    style="width: 100%"
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :placeholder="placeholder"
    :loadData="asyncLoadTreeData"
    :value="treeValue"
    :treeData="treeData"
    :multiple="multiple"
    @change="onChange"
    @search="onSearch"
  >
  </a-tree-select> -->
</template>

<script>
import { UploadFileService, EN_RESOURCE_CODE } from '@/utils/oss/upload_service.ts'

export default {
  name: 'DUpload',  
  props: {
    value: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      fileList: [],
      uploading: false,
      text: '上传文件',
      fileAddress: '',
    }
  },
  created() {
    if (this.value) {
      this.text = this.value
    }
  },
  watch: {
    value() {
      this.text = this.value
    },
  },
  methods: {
    handleRemove(file) {
      this.fileList = []
      this.text = file.name
    },
    beforeUpload(file) {
      this.fileList = [file]
      this.text = file.name
      this.uploading = true
      this.doUpload()
      return false
    },
    async doUpload() {
      const uploadResult = await UploadFileService.uploadFile2(this.fileList[0])
      this.fileAddress = uploadResult.fileAddress
      this.$emit('change', this.fileAddress)
      this.uploading = false
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
}
</script>